/** Envoltorio estándar del micro admin-core (OpenAPI: ResponseDTOObject). */
export interface ApiResponse<T = unknown> {
  estatus?: string;
  mensaje?: string;
  lista?: T[];
  dto?: T;
  codError?: string;
  totalPages?: number;
  totalElements?: number;
}

export function isApiError(res: ApiResponse): boolean {
  if (res.codError) {
    return true;
  }
  const status = String(res.estatus ?? '').trim().toUpperCase();
  return status === 'ERROR' || status === 'FAIL' || status === '0';
}

export function assertApiOk<T>(res: ApiResponse<T>, fallback = 'Error en la operación'): void {
  if (isApiError(res)) {
    throw new Error(res.mensaje?.trim() || fallback);
  }
}

export function httpErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'error' in err) {
    const httpErr = err as { error?: { mensaje?: string; message?: string } | string };
    const body = httpErr.error;
    if (typeof body === 'string' && body.trim()) {
      return body;
    }
    if (body && typeof body === 'object') {
      return body.mensaje?.trim() || body.message?.trim() || fallback;
    }
  }
  if (err instanceof Error && err.message) {
    return err.message;
  }
  return fallback;
}
